

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/New-Products/Ceratina.jpg";
import thumb2 from "../assets/images/New-Products/Ceratina.jpg";
import howToUseThumb from "../assets/images/hair-breadcrum.jpg";
import howToUseVideo from "../assets/Video/hair.mp4";
import BredcrumpImage from "../assets/images/hair-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const CeratinaProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Transforming Hair Health Through Scientific Innovation."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Hair Care", to: "/HairCareProducts" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb2].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>Ceratina </h2>
              <p className="sub-heading text-muted" >Nutritional Hair Supplement</p>
              <h5>Product Overview</h5>
              <p>

                {/* <ul>
                  <li>Ceratina is an oral Hair Recovery & Regrowth Nutritional Supplement.</li>
                  <li>Ceratina combines key Anti-oxidants, Anti-lnflammatory Agents & Botanical 5-a Reductase lnhibitors which is a good adjunct in treatment of AGA in both men & women.</li>
                  <li>A Unique 5 in 1 Hair Recovery & Re-Growth Nutritional Supplements (for Men & Women)</li>
                </ul> */}
                Ceratina Capsule is a next-generation nutraceutical designed to address hair loss through a
                circadian biology-driven approach, combined with proven DHT blockers, antioxidants, and
                nutritional support to manage hair health
              </p>
              <p> A Unique 5 in 1 Hair Recovery & Re-Growth Nutritional Supplements (for Men & Women)</p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >

              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">Ceratina?</span>
                </h3>
                <p>
                  1-2 capsules per day with water for minimum 24 weeks or more depending upon the severity of condition or as suggested by physician.
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "application", "ingredients"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <p><strong>1. Benefits</strong></p>
                  <ul>
                    <li>
                      It helps to restore and support thicker and faster growth of thinning hair through five key pathways:
                      <ul>
                        <li>Supporting stimulation of hair growth</li>
                        <li>Helping support prevention of hair loss</li>
                        <li>Nutritional support to help block DHT</li>
                        <li>Delivering key antioxidants</li>
                        <li>Supplying anti-inflammatory benefits</li>
                      </ul>
                    </li>

                    <li>
                      The singular consumption of Soy Isoflavones lowers DHT by 15%.
                      The combination of Soy Isoflavones and Green Tea synergistically lowers DHT by 80%.
                    </li>
                  </ul>


                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>
                        <strong>Rcommended Usage:</strong>  1-2 capsules per day with water for minimum 24 weeks or more depending upon the severity of condition or as suggested by physician.
                      </li>

                    </ul>

                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>

                    <ul>
                      <li>
                        <strong>Beta Sitosterol 50 mg</strong> – Plant phytosterols such as Beta-Sitosterol nourish and support a healthy and normal androgen sex hormone state in the body. They also support reduced inflammation and help inhibit DHT.
                      </li>

                      <li>
                        <strong>Omega 3,6 – 75 mg</strong> – A key family of polyunsaturated essential fats obtained from dietary sources as the body cannot synthesize them sufficiently. They support reduced inflammation, which is commonly associated with hair loss and scalp disorders.
                      </li>

                      <li>
                        <strong>Soy Isoflavone – 150 mg</strong> – Helps nourish and support a balanced androgen sex hormone state. Provides potent antioxidant protection and helps prevent oxidative-stress–induced aging of the hair follicle.
                      </li>

                      <li>
                        <strong>Melatonin – 1.5 mg</strong> – Regulates circadian rhythms and acts as a cyto-protective, apoptosis-suppressive agent in hair follicles. Prevents telogen phase by reducing apoptosis in HF keratinocytes and protects the follicle from stress-induced damage. Melatonin is also a powerful antioxidant that supports DNA repair.
                      </li>

                      <li>
                        <strong>Green Tea Extract – 125 mg</strong> – Catechins such as EGCG help suppress DHT, support hair growth, and reduce inflammation. They stimulate hair growth and prolong the anagen phase by promoting dermal papilla cell proliferation and reducing apoptosis.
                      </li>

                      <li>
                        <strong>Vitamin D – 2.5 mcg</strong> – Plays a key role in stimulating new and existing hair follicles. Vitamin D deficiency can stunt new hair growth.
                      </li>
                    </ul>


                  </p>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default CeratinaProductDetails;
